import axios from 'axios';
import { ajaxUri } from '../../../consts/index';
import { l } from '../../../functions';

export const fetchMenu = (loadIncrement = null) => {
    return dispatch => {
		axios({
			method: 'post',
			url: ajaxUri,
			data: {
				request : 'getMenu'
			}
		})
		.then(result => {
            if( loadIncrement )
                dispatch({type:'LOAD_INCREMENT',toAdd:parseInt(loadIncrement)})
            
            dispatch({type:'SET_MENU',menu:result.data});
		}).catch(error => {
			console.error(l('Cannot fetch menu'));
        });
    }
}